import { Dialog } from "@headlessui/react";
import { ModalHeaderBox, ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import * as yup from "yup";
import FormController from "../../components/fields/FormController";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";

export type FamilyEmailModalProp = {
  familyEmailValue?: string[];
  onSubmit: (data: FamilyEmailForm) => void;
}
export interface FamilyEmailForm {
  email1?: string;
  email2?: string;
  email3?: string;
  email4?: string;
  email5?: string;
}

export const FamilyEmailModal = ({
  open,
  toggle,
  closeOnClickOutside,
  familyEmailValue,
  onSubmit,
}: ModalProp & FamilyEmailModalProp) => {
  const schema = yup.object({
    email1: yup.string().email(),
    email2: yup.string().email(),
    email3: yup.string().email(),
    email4: yup.string().email(),
    email5: yup.string().email(),
  });

  const {control, handleSubmit, setValue} = useForm<FamilyEmailForm>({
    resolver: yupResolver(schema)
  });

  useEffect(() => {
    setValue('email1', familyEmailValue?.at(0));
    setValue('email2', familyEmailValue?.at(1));
    setValue('email3', familyEmailValue?.at(2));
    setValue('email4', familyEmailValue?.at(3));
    setValue('email5', familyEmailValue?.at(4));
  },[familyEmailValue, setValue]);

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center mt-3">
              <ModalHeaderBox title={"追加するメールアドレスを入力してください"}/>
            </div>
            <div className="px-2 flex-col space-y-4">
              <FormController
                control={control}
                className={"flex items-center space-x-4"}
                name={"email1"}
                label={"1"}
                type={"text"}
              />
              <FormController
                control={control}
                className={"flex items-center space-x-4"}
                name={"email2"}
                label={"2"}
                type={"text"}
              />
              <FormController
                control={control}
                className={"flex items-center space-x-4"}
                name={"email3"}
                label={"3"}
                type={"text"}
              />
              <FormController
                control={control}
                className={"flex items-center space-x-4"}
                name={"email4"}
                label={"4"}
                type={"text"}
              />
              <FormController
                control={control}
                className={"flex items-center space-x-4"}
                name={"email5"}
                label={"5"}
                type={"text"}
              />
            </div>
          </div>
          <ModalFoterBox>
            <Button outline className={"mr-2 w-[132px]"} onClick={toggle}>
              キャンセル
            </Button>
            <Button submit className={"w-[132px]"}>
              登録
            </Button>
          </ModalFoterBox>
        </form>
      </Dialog.Panel>
    </Modal>
  );
}